
if (!('trim' in String.prototype)) {
    String.prototype.trim = function () {
        return this.replace(/^\s*|\s*$/g, '');
    };
}

if (!('replaceAll' in String.prototype)) {
    String.prototype.replaceAll = function (find, replace) {
        return this.replace(new RegExp(this.sanitizeForRegExp(), 'g'), replace);
    };
}

if (!('sanitizeForRegExp' in String.prototype)) {
    String.prototype.sanitizeForRegExp = function () {
        return this.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };
}

if (!('indexOf' in Array.prototype)) {
    Array.prototype.indexOf = function (elt /*, from*/) {
        var len = this.length >>> 0;

        var from = Number(arguments[1]) || 0;
        from = (from < 0) ? Math.ceil(from) : Math.floor(from);
        if (from < 0)
            from += len;

        for (; from < len; from++) {
            if (from in this &&
          this[from] === elt)
                return from;
        }
        return -1;
    };
}

if (!('remove' in Array.prototype)) {
    Array.prototype.remove = function (el /*, g*/) { //(el "Object - Element to find", [g "Boolean - Global/multiple matches"])
        var i, g;

        g = (arguments.length > 0) ? arguments[1] : false;

        if (g) {
            while (i != -1) {
                i = this.indexOf(el);
                if (i > -1) {
                    this.splice(i, 1);
                }
            }
        } else {
            i = this.indexOf(el);
            if (i > -1) {
                this.splice(i, 1);
            }
        }
    };
}

if (!('map' in Array.prototype)) {
    Array.prototype.map = function (mapper, that /*opt*/) {
        var other = new Array(this.length);
        for (var i = 0, n = this.length; i < n; i++) {
            if (i in this) {
                other[i] = mapper.call(that, this[i], i, this);
            }
        }
        return other;
    };
}

if (!('itemExists' in Array.prototype)) {
    Array.prototype.itemExists = function (item) {
        var i, len;
        len = this.length;
        for (i = 0; i < len; i++) {
            if (this[i] == item) {
                return true;
            }
        }
    };
}

if (!('objectExists' in Array.prototype)) {
    Array.prototype.objectExists = function (x, prop) {
        var i, len;
        len = this.length;
        objectsAreSame = false;
        for (i = 0; i < len; i++) {
            if (x[prop] == this[i][prop]) {
                objectsAreSame = true;
                break;
            }
        }
        return objectsAreSame;
    };
}

if (!('objectIndexByProperty' in Array.prototype)) {
    Array.prototype.objectIndexByProperty = function (x, prop) {
        var i, len;
        len = this.length;
        objectIndex = -1;
        for (i = 0; i < len; i++) {
            if (x[prop] == this[i][prop]) {
                objectIndex = i;
                break;
            }
        }
        return objectIndex;
    };
}

if (!('itemIndex' in Array.prototype)) {
    Array.prototype.itemIndex = function (item) {
        var i, len, index;
        len = this.length;
        index = -1;
        for (i = 0; i < len; i++) {
            if (this[i] == item) {
                index = i;
                break;
            }
        }
        return index;
    };
}

if (!('filter' in Array.prototype)) {
    Array.prototype.filter = function (fun /*, thisp*/) {
        //filter LOOPS THROUGH EACH ITEM IN THE ARRAY AND RETURNS 
        //AN ARRAY OF ITEMS RETURNING TRUE FROM THE FUNCTION PARAMETER fun.
        var i, len, res, thisp, val;
        len = this.length;
        if (typeof fun != 'function') {
            throw new TypeError();
        }
        res = [];
        thisp = arguments[1];
        for (i = 0; i < len; i++) {
            if (i in this) {
                val = this[i]; // in case fun mutates this
                if (fun.call(thisp, val, i, this)) {
                    res.push(val);
                }
            }
        }
        return res;
    };
}

if (!('getDayName' in Date.prototype)) {
    Date.prototype.getDayName = function (shortName) {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        if (shortName) {
            return days[this.getDay()].substr(0, 3);
        } else {
            return days[this.getDay()];
        }
    };
}

if (!('getMonthName' in Date.prototype)) {
    Date.prototype.getMonthName = function (shortName) {
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        if (shortName) {
            return months[this.getMonth()].substr(0, 3);
        } else {
            return months[this.getMonth()];
        }
    };
}

if (!('getShortTime' in Date.prototype)) {
    Date.prototype.getShortTime = function () {
        var hrs, mins;
        hrs = (this.getHours() < 10) ? '0' + this.getHours() : this.getHours();
        mins = (this.getMinutes() < 10) ? '0' + this.getMinutes() : this.getMinutes();
        return hrs + ':' + mins;
    };
}

if (!('getDateFormatted' in Date.prototype)) {
    Date.prototype.getDateFormatted = function (format) {
        var day, mon, year, dt;
        switch (format) {
            case 'dd/MM/yyyy':
                day = (this.getDate() < 10) ? '0' + this.getDate() : this.getDate();
                mon = ((this.getMonth() + 1) < 10) ? '0' + (this.getMonth() + 1) : (this.getMonth() + 1);
                year = this.getFullYear();
                dt = day + '/' + mon + '/' + year;
                break;
            case 'dd/MM/yy':
                day = (this.getDate() < 10) ? '0' + this.getDate() : this.getDate();
                mon = ((this.getMonth() + 1) < 10) ? '0' + (this.getMonth() + 1) : (this.getMonth() + 1);
                year = String(this.getFullYear()).substr(2, 2);
                dt = day + '/' + mon + '/' + year;
                break;
            case 'dd MMMM yyyy':
                day = (this.getDate() < 10) ? '0' + this.getDate() : this.getDate();
                mon = this.getMonthName();
                year = this.getFullYear();
                dt = day + ' ' + mon + ' ' + year;
                break;
            case 'dd MMM yyyy':
                day = (this.getDate() < 10) ? '0' + this.getDate() : this.getDate();
                mon = this.getMonthName(true);
                year = this.getFullYear();
                dt = day + ' ' + mon + ' ' + year;
                break;
        }
        return dt;
    };
}

if (!Array.prototype.clean) {
	Array.prototype.clean = function (deleteValue) {
		for (var i = 0; i < this.length; i++) {
			if (this[i] == deleteValue) {
				this.splice(i, 1);
				i--;
			}
		}
		return this;
	};
}

if (!Array.prototype.removeEmptyEntries) {
	Array.prototype.removeEmptyEntries = function () {
		return this.clean('');
	};
}

if (!Array.prototype.itemMatchingPropertyValue) {
	Array.prototype.itemMatchingPropertyValue = function (propName, propValue) {

		//RETURNS *FIRST* OBJECT IN THE ARRAY THAT HAS A PROPERTY NAMED propName THAT MATCHES propValue

		//THIS FUNCTION MUST USE THE equality (==) OPERATOR RATHER THAN THE identity (===) OPERATOR AS WE DON'T NECESSARILY 
		//KNOW THE DATATYPE BEING USED FOR COMPARISON. FOR EXAMPLE NUMBERS BEING USED IN CODE AS Number (integers) ARE OFTEN 
		//STORED AS STRINGS WHEN SERIALIZED TO JSON SO WE'LL OFTEN BE COMPARING 12345 == '12345'.

		var i, len, objectIndex;
		len = this.length;
		objectIndex = -1;
		if (len > 0) {
			for (i = 0; i < len; i++) {
				if (this[i][propName] == propValue) {
					return this[i];
				}
			}
		} else {
			if (this[propName] == propValue) {
				return this;
			}
		}

		return null;
	};
}

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		position = position || 0;
		return this.substr(position, searchString.length) === searchString;
	};
}

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString, position) {
		var subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position -= searchString.length;
		var lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}